/**
 * API Configuration for AVO Protocol Explorer
 * Centralized configuration for all RPC calls
 */

export const API_CONFIG = {
  // Use environment variable or fallback to localhost for development
  RPC_URL: process.env.REACT_APP_API_URL || 'http://localhost:9944',
  
  // WebSocket URL (if needed in the future)
  WS_URL: process.env.REACT_APP_WS_URL || 'ws://localhost:8080',
  
  // Timeout for RPC calls (in milliseconds)
  TIMEOUT: 30000,
  
  // Retry configuration
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000,
};

// Export as default for convenience
export default API_CONFIG;
